import React from "react";

const Info = () => {
  return (
    // <div className="about__info grid">
    //   <div className="about__box">
    //     <i class="bx bx-award about__icon"></i>
    //     <h3 className="about__title">Experience</h3>
    //     <span className="about__subtitle">8 Years Working</span>
    //   </div>
    //   <div className="about__box">
    //     <i class="bx bx-briefcase-alt about__icon"></i>
    //     <h3 className="about__title">Completed</h3>
    //     <span className="about__subtitle">48 + Projects</span>
    //   </div>
    //   <div className="about__box info__grid">
    //     <i class="bx bx-support about__icon"></i>
    //     <h3 className="about__title">Support</h3>
    //     <span className="about__subtitle">Online 24/7</span>
    //   </div>
    // </div>
    <div className="about__info grid">
      <div className="about__box">
        <i class="bx bx-shield-alt-2 about__icon"></i>
        <h3 className="about__title">OWASP Top 10</h3>
        <span className="about__subtitle">Voorivex</span>
      </div>
      <div className="about__box">
        <i class="bx bx-code-alt about__icon"></i>
        <h3 className="about__title">Web Dev Bootcamp</h3>
        <span className="about__subtitle">Udemy</span>
      </div>
      <div className="about__box info__grid">
        <i class="bx bx-lock-alt about__icon"></i>
        <h3 className="about__title">Security+</h3>
        <span className="about__subtitle">Udemy</span>
      </div>
    </div>
  );
};

export default Info;
